import { useContext, useEffect, useState } from 'react'
import { NavContext } from '../../../context/global_context'
import Modal, { ModalBody, ModalHeader } from '../../common/Modal'
import { PromotedBranchContext } from '../context/context'
import { getRequest } from '../../../services/base'
import SelectMakeModelModal from './SelectMakeModel'
import { useSearchParams } from 'react-router-dom'

const TracerPreviewModal = () => {
  const [state, dispatch] = useContext(PromotedBranchContext)
  const [navState, navDispatch] = useContext(NavContext)
  const [showVehicleSelect, setShowVehicleSelect] = useState(false)
  const [searchParams, setSearchParams] = useSearchParams()

  useEffect(() => {
    validateBranch()
  }, [])

  const getTracerPreviewData = async () => {
    navDispatch({
      type: 'loader',
      data: {
        caption: 'Loading tracer preview data ...',
        showLoader: true,
      },
      notification: {},
    })

    let res = await getRequest(`/api/tracer/preview/get/`)

    navDispatch({
      type: 'loader',
      data: {},
      notification: {},
    })
    if (res?.msg === 'Please select one make model') {
      setShowVehicleSelect(true)
    }
  }

  const validateBranch = async () => {
    navDispatch({
      type: 'loader',
      data: {
        caption: 'Validating branch with git ...',
        showLoader: true,
      },
      notification: {},
    })
    let res = await getRequest(
      `/api/tracer/preview/validate/?data_version=${searchParams.get('data_version') ? searchParams.get('data_version') : ''}`
    )
    if (res?.data) {
      getTracerPreviewData()
    } else {
      navDispatch({
        type: 'loader',
        data: {},
        notification: {},
      })
    }
  }

  return (
    <Modal
      onClose={() => {
        dispatch({
          type: 'show_hide_tracer_preview',
          data: false,
        })
      }}
      show={state?.showTracerPreviewPopup}
      size={`w-full`}
    >
      {showVehicleSelect ? (
        <ModalHeader className={'text-white p-1'}>
          {state?.tracerPreviewData?.vehicle?.name
            ? `Tracer Preview for ${state?.tracerPreviewData?.vehicle?.name}`
            : `Select Make Model For Preview`}
        </ModalHeader>
      ) : (
        <ModalHeader className={'text-white'}>Tracer Preview</ModalHeader>
      )}

      <ModalBody>
        {showVehicleSelect ? (
          <SelectMakeModelModal />
        ) : (
          <div className="text-center text-white">
            Branch Not yet pushed to Git, Please cordinate with respective
            person
          </div>
        )}
      </ModalBody>
    </Modal>
  )
}

export default TracerPreviewModal
